/**
 *@ngdoc directive
 *@name cbl.insuranceloanpmi.mf.directive:creasTable
 *@restrict E
 *@scope
 *@description Direttiva utilizzata per contenere lo ui-grid
 *@param {Object} data - Oggetto contenente i dati dell tabella
 *@param {Object} label - Oggetto contenente i parametri di configurazione della tabella
 *@param {String} [messaggioCustom] - Messaggio personalizzato da far visualizzare al posto di quello standard
 *@param {Boolean} [clickAbilitato] - Abilita o disabilita il click sugli elementi della tabella
 *@param {Function} [apriPagina] - Funzione di callback scatenata sul click di una riga della tabella
 */
(function() {
	"use strict";
	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasTable", ['CONSTANTS', function(CONSTANTS) {
		var link = function (scope, elem, attrs, model) {
		};

		var controller = function($scope, $state, $stateParams, labelSrvc, uiGridConstants) {
			$scope.msg = labelSrvc.getLabel;
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.uiGridConstants = uiGridConstants;
			var self = this;
			
			this.gridOptions = {
				enableSorting: true,
	            enableColumnMenus: false,
	            enableGrouping: false,
	            enableFiltering: true,
	            treeRowHeaderAlwaysVisible: false,
	            useExternalPagination: $scope.paginazioneEsterna ? $scope.paginazioneEsterna : false,
	            paginationPageSizes: [10, 25, 50],
	            paginationPageSize: 10,
	            paginationCurrentPage: 1,
	            enableRowSelection: true,
	            noUnselect: true,
	            multiSelect: false,
	            enableRowHeaderSelection: false,
	            showGridFooter: false,
	            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
	            enableColumnResizing: true,
	            columnDefs: $scope.label,
	            data: $scope.data,
	            onRegisterApi: function (gridApi) {
	            	self.gridApi = gridApi;
            		self.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
        				$scope.apriPagina({row: row.entity});
            		});
	            }
			};
			
			this.getTableHeight = function() {
		       var rowHeight = 30;
		       var headerHeight = 65;
		       var footerHeight = 35;
		       var totalItems = self.gridOptions.data && self.gridOptions.data.length ? self.gridOptions.data.length : 0;
		       
		       if (self.gridOptions.paginationPageSize !== totalItems) {
		    	   totalItems = self.gridOptions.paginationPageSize;
		       }
		       
		       return {
		          height: (totalItems * rowHeight + headerHeight + footerHeight) + "px"
		       };
		    };
		};

		controller.$inject = ['$scope', '$state', '$stateParams', 'LabelSrvc', 'uiGridConstants'];

		return {
			restrict: "E",
			scope: {
				data: '=',
				label: '=',
				messaggioCustom: '@?',
				clickAbilitato: '=?',
				apriPagina: '&?',
				paginazioneEsterna: '=?'
			},
			controller: controller,
			controllerAs: "creasTableCtrl",
			templateUrl: CONSTANTS.BASE_ROOT + "widgets/creasTable/creasTable.html",
			link: link
		};
	}]);
}());


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasTable/creasTableDrct.js
// module id = 8
// module chunks = 0 1